import { useState, useCallback } from 'react';
import { pw9119Api } from '../../../services/pw9119Api';
import { F919 } from '../../../services/pw9119Api';

export function usePW9119Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pw9119Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const resolveAllNames = useCallback(async (master: Partial<F919>) => {
    const entries: [string, string, string][] = [];
    if (master.f919_11) {
      entries.push(['employee', 'employee', master.f919_11]);
    }
    if (master.f919_14) {
      entries.push(['department', 'department', master.f919_14]);
    }
    if (entries.length === 0) return;

    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pw9119Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveSingleName, resolveAllNames, clearNames };
}
